import { configureStore, combineReducers, ReducersMapObject } from '@reduxjs/toolkit';
import { dcpcApi } from 'Services/api/dcpcApi';
import { initialReducers } from './initialReducers';

const createReducer = (asyncReducers: ReducersMapObject) => combineReducers({
  // перезаписываем initialReducers, т.к. начальные редюсеры стора затираются
  ...initialReducers,
  ...asyncReducers,
});

/**
 * Возвращает `store`, в который можно добавлять редюсеры (слайсы) в любом месте.  
 * **note***: `store` имеет начальные редюсеры
 * * AUTH_SLICE
 * * APP_SLICE
 * * DICTIONARIES_SLICE
 * @example
 * import store from 'Features/App/store';
 * import someReducer, { SLICE_NAME } from './someSlice';
 * store.injectReducer(SLICE_NAME, someReducer);
 */
export function createAsyncStore() {
  const store = configureStore({
    // Нужен по дефолту хоть один редюсер
    // reducer: { init: () => null },
    // note: ставлю сюда начальные редюсеры, чтобы в типе для state они отображались, иначе не будет
    reducer: initialReducers,
    // @ts-ignore
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: false,
      // immutableCheck: {
      // сообщает, если процесс вставки объекта в хранилище занял больше указанного времени (ms)
      //   warnAfter: 100,
      // },
      serializableCheck: {
        // сообщает, если процесс вставки объекта в хранилище занял больше указанного времени (ms)
        warnAfter: 180,
      },
    }).concat(dcpcApi.middleware),
  });

  // для отслеживания зарегистрированных асинхронных(динамически добавленных) редюсеров
  // @ts-ignore asyncReducers
  store.asyncReducers = {};

  // добавляет асинхронный редюсер и создает новый комбинированный редюсер
  // @ts-ignore asyncReducers
  store.injectReducer = (key, asyncReducer) => {
  // @ts-ignore asyncReducers
    store.asyncReducers[key] = asyncReducer;
    // @ts-ignore asyncReducers
    store.replaceReducer(createReducer(store.asyncReducers));
  };
  return store;
}
